import { useEffect, useState } from "react";
const photo = require("./assets/opfa.jpeg");
const background = require("./assets/background.svg");

function App() {
  const [showImg, setShowImg] = useState(false);
  const [sequence, setSequence] = useState<string[]>([]);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      const key = event.key;

      // Update the sequence of keys
      setSequence((prevSequence) => {
        // Only keep the last two keys in the sequence
        const updatedSequence = [...prevSequence, key].slice(-2);

        // Check if the last two keys are "9" and "2"
        if (updatedSequence[0] === "9" && updatedSequence[1] === "2") {
          // Show the image
          setShowImg(true);

          // Hide the image after 2 seconds
          setTimeout(() => {
            setShowImg(false);
          }, 2000);
        }

        return updatedSequence;
      });
    };

    // Attach the event listener
    window.addEventListener("keydown", handleKeyPress);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <div className="container backgroundImg">
      <h1 className="border-bottom">Coming soon...</h1>
      <a
        href="https://www.tiktok.com/@strengthandpowerpt"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="flex-row color-white link-hover">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            className="bgSvg"
            viewBox="0 0 64 64"
          >
            <path
              fill="#cccccc"
              d="M 23.773438 12 C 12.855437 12 12 12.854437 12 23.773438 L 12 40.226562 C 12 51.144563 12.855438 52 23.773438 52 L 40.226562 52 C 51.144563 52 52 51.145563 52 40.226562 L 52 23.773438 C 52 12.854437 51.145563 12 40.226562 12 L 23.773438 12 z M 21.167969 16 L 42.832031 16 C 47.625031 16 48 16.374969 48 21.167969 L 48 42.832031 C 48 47.625031 47.624031 48 42.832031 48 L 21.167969 48 C 16.374969 48 16 47.624031 16 42.832031 L 16 21.167969 C 16 16.374969 16.374969 16 21.167969 16 z M 32.740234 19.693359 L 32.740234 36.294922 C 32.740234 38.576922 30.756031 39.755859 29.332031 39.755859 C 28.259031 39.755859 25.818359 38.914578 25.818359 36.267578 C 25.818359 33.488578 28.095422 32.779297 29.357422 32.779297 C 30.092422 32.779297 30.380859 32.9375 30.380859 32.9375 L 30.380859 28.507812 C 30.380859 28.507813 29.830172 28.425781 29.201172 28.425781 C 24.682172 28.425781 21.464844 32.083578 21.464844 36.267578 C 21.464844 39.802578 24.229297 44.082031 29.279297 44.082031 C 34.658297 44.082031 37.121094 39.595969 37.121094 36.292969 L 37.121094 28.058594 C 37.121094 28.058594 39.518422 29.736328 42.732422 29.736328 L 42.732422 25.541016 C 39.045422 25.278016 37.0745 22.801359 36.9375 19.693359 L 32.740234 19.693359 z"
            ></path>
          </svg>
          <h2>@strengthandpowerpt</h2>
        </div>
      </a>
      {showImg && <img className="imageStart" src={photo} alt="OPFA" />}
    </div>
  );
}

export default App;
